import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error: error };
  }

  componentDidCatch(error, info) {
    console.error("SYNTRIX crashed:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f7f3ee", color: "#2c2420", fontFamily: "'DM Sans', system-ui, sans-serif", padding: 24, textAlign: "center" }}>
          <div>
            <div style={{ fontFamily: "Georgia,serif", fontSize: 24, fontWeight: 500, marginBottom: 10 }}>Something went wrong</div>
            <div style={{ fontSize: 13, color: "#7a6e64", marginBottom: 18, maxWidth: 480 }}>{String(this.state.error && this.state.error.message || this.state.error)}</div>
            <button
              onClick={function() { window.location.reload(); }}
              style={{ background: "#2c2420", color: "#f7f3ee", fontFamily: "inherit", fontWeight: 600, fontSize: 13, letterSpacing: 1.5, padding: "12px 28px", border: "none", borderRadius: 100, cursor: "pointer" }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
